<div class="gpt-wrapper-container">
    @if (!isOptionSelected()) {
    <h1>Know more about this product</h1>

    <ul>
        @for (chatOption of chatGptOptionsToShow(); track chatOption.title) {
        <li class="d-flex align-items-center justify-content-between" (click)="selectChatGptOption(chatOption)">
            <div class="d-flex align-items-center">
                <img [src]="chatOption.iconUrl" class="option-icon" />

                <div>
                    <p>{{ chatOption.title }}</p>
                    <p class="caption">
                        {{ chatOption.caption }}
                    </p>
                </div>
            </div>

            <img src="/assets/images/down-arrow.svg" class="nav-icon" />
        </li>
        }
    </ul>
    <!-- View More Section -->
    @if (chatGptOptions().length > 4) {
    <div class="view-more-section d-flex flex-row justify-content-end">
        <div class="view-more-content">
            @if (!isExpanded()) {
            <span (click)="toggleViewMore()" class="view-more">View More</span>
            } @if (isExpanded()) {
            <span (click)="toggleViewMore()" class="view-more">View Less</span>
            }
        </div>
    </div>
    } }

    <!-- selected option -->
    @if (hasSelectedOption()) {
    <div class="selected-option-container">
        <div (click)="resetChatGptResponse()" class="d-flex align-items-center back-btn-container">
            <img [src]="IMAGE_URLS.arrowLeftIcon" class="back-icon" />
            <span>Back</span>
        </div>

        <div class="d-flex align-items-center selected-option-content">
            <img [src]="selectedChatGptOption()?.iconUrl" class="option-icon" />

            <div>
                <p>{{ selectedChatGptOption()?.title }}</p>
                <p class="caption">
                    {{ selectedChatGptOption()?.caption }}
                </p>
            </div>
        </div>

        @if (selectedChatGptOption()?.type === ChatGptOptionType.Compare) {
        <div class="d-flex input-box-container">
            <form (submit)="chatGptPrompt(selectedChatGptOption()!)" class="input-form" [class.disabled]="chatButtonLoading()">
                <input #inputBox placeholder="Start Typing product name..." type="text" autofocus [formControl]="chatInput" class="input-box" [disabled]="chatButtonLoading()" />
            </form>
            @if (hasSelectedOption() && !chatGptResponse()) {
            <button type="button" class="input-btn" [class.disabled]="chatButtonLoading()" (click)="chatGptPrompt(selectedChatGptOption()!)">
                Let's Go
            </button>
            } @if (hasSelectedOption() && chatGptResponse()) {
            <button type="button" class="input-btn" [class.disabled]="chatButtonLoading()" (click)="resetChatGptResponse()">
                Clear
            </button>
            }
        </div>
        }
    </div>
    }

    <!-- results section -->
    @if (hasSelectedOption() && chatGptResponse(); as chatGptResponse) {
    <div class="result-container">
        <h2>Here's what we got for you..</h2>
        <p class="caption">
            This is an AI generated information from the relevant resources available over the internet.
            Please verify this on your end as well.
        </p>

        <div class="result-content">
            <span [innerText]="chatGptResponse"></span>
        </div>
    </div>
    }

    <!-- loading state... -->
    @if (chatButtonLoading()) {
    <webstore-chat-gpt-shimmer></webstore-chat-gpt-shimmer>
    }

    <!-- results Not found section -->
    @if (error() && !chatButtonLoading()) {
    <div class="d-flex flex-column align-items-center justify-content-center not-found-container">
        <img src="https://assets.hyperinvento.com/www_imaginext_com/assets/imaginext-assets/images/result-not-fount.svg" class="not-found-icon" />

        <p class="caption">Not found what you are looking for...</p>
    </div>
    }
</div>